/* global customElements, window */
import WarpElement from '@warp-ds/elements-core';
import { css, html } from 'lit';
import '@warp-ds/elements/components/button';
import pulse from '@finn-no/pulse-sdk';

export class StaticBanner extends WarpElement {
	static styles = [
		...WarpElement.styles, // Adds the global styles
		css`
			/** The line below is where the injected CSS goes, removing it means you get no CSS from the design system **/
			*,:before,:after{--w-rotate:0;--w-rotate-x:0;--w-rotate-y:0;--w-rotate-z:0;--w-scale-x:1;--w-scale-y:1;--w-scale-z:1;--w-skew-x:0;--w-skew-y:0;--w-translate-x:0;--w-translate-y:0;--w-translate-z:0}@media (min-width:768px){.md\\:h3{font-weight:700;font-size:var(--w-font-size-l);line-height:var(--w-line-height-l)}}.aspect-ratio{aspect-ratio:auto}.table{display:table}.static{position:static}.max-h-full{max-height:100%}.max-w-4\\/10{max-width:40%}.my-24{margin-top:2.4rem;margin-bottom:2.4rem}.object-cover{object-fit:cover}.text-14{font-size:var(--w-font-size-s);line-height:var(--w-line-height-s)}@media (min-width:480px){.sm\\:p-24{padding:2.4rem}}@media (min-width:768px){.md\\:my-16{margin-top:1.6rem;margin-bottom:1.6rem}};
		`,
	];

	static properties = {
		host: { type: String },
		bannerImage: { type: String },
		bannerImageTori: { type: String },
		cardId: { type: String },
		buttonText: { type: String },
	};

	_trackBannerClick() {
		pulse.trackEvent({
			type: 'Click',
			intent: 'Open',
			name: 'Braze content card',
			object: {
				type: 'UIElement',
				elementType: 'Button',
				position: `Frontpage:${this.buttonText}`,
				name: this.cardId,
			},
			vertical: { name: 'common_pages' },
		});
	}

	_trackViewEvent() {
		pulse.trackPageView({
			name: 'Braze content card',
			intent: 'Show',
			object: {
				type: 'UIElement',
				elementType: 'Card',
				position: `Frontpage:${this.buttonText}`,
				name: this.cardId,
			},
			vertical: { name: 'common_pages' },
		});
	}
	render() {
		if (this.host.includes('finn')) {
			this.cardId = 'tjt24w31_frontpage_web';
			this.buttonText = this.i18n.t({
				id: 'bip.banner.link',
				message: 'Make a bargain!',
			});

			const header = this.i18n.t({
				id: 'bip.banner.header',
				message: "Now there's 50% off using Fiks ferdig!",
			});

			const subHeader = this.i18n.t({
				id: 'bip.banner.subheader',
				message: 'Applies to small packages up to Sunday, August 11. Secure payment is extra.',
			});

			if (typeof window !== 'undefined') {
				this._trackViewEvent();
			}

			return html` <section
				id="frontpage-banner"
				card-id="${this.cardId}"
				class="flex justify-between grow relative overflow-hidden rounded-8 shadow-m my-24"
				aria-labelledby="fp-banner-header"
			>
				<div class="p-16 sm:p-24">
					<h2 class="h4 md:h3" id="fp-banner-header">${header}</h2>
					<p class="inline text-14 md:my-16">${subHeader}</p>
					<div class="mr-8 mt-16">
						<w-button
							id="frontpage-banner-link"
							variant="primary"
							small
							href="/bap/forsale/search.html?shipping_exists=true"
							@click="${this._trackBannerClick}"
						>
							${this.buttonText}
						</w-button>
					</div>
				</div>
				<img
					src="${this.bannerImage}"
					alt="${this.i18n.t({
						id: 'bip.banner.image.ariaLabel',
						message: 'Parcel on a table',
					})}"
					class="flex flex-1 items-center max-w-4/10 object-cover max-h-full"
					style="aspect-ratio: 10/3;"
				/>
			</section>`;
		}

		if (this.host.includes('tori')) {
			this.cardId = 'tori-diili-onboarding';
			this.buttonText = this.i18n.t({ id: 'bip.tori.banner.link-text', message: 'Read more' });
			if (typeof window !== 'undefined') {
				this._trackViewEvent();
			}
			return html` <section
				id="frontpage-banner"
				card-id="${this.cardId}"
				class="flex justify-between grow relative overflow-hidden rounded-8 shadow-m my-24"
				aria-labelledby="fp-banner-header"
			>
				<div class="p-16 sm:p-24">
					<h2 class="h4 md:h3" id="fp-banner-header">
						${this.i18n.t({
							id: 'bip.tori.banner.header',
							message: 'ToriDiili - Safe payment & smooth delivery',
						})}
					</h2>
					<p class="inline text-14 md:my-16">
						${this.i18n.t({
							id: 'bip.tori.banner.text',
							message: `With Tori's new payment and transport service, you can buy and sell goods by post all over Finland without additional messaging.`,
						})}
					</p>
					<div class="mr-8 mt-16">
						<w-button
							id="frontpage-banner-link"
							variant="primary"
							small
							href="/toridiili?utm_source=tori&utm_medium=content_card&utm_campaign=recommerce24w16_toridiili&utm_content=free_shipping"
							@click="${this._trackBannerClick}"
						>
							${this.buttonText}
						</w-button>
					</div>
				</div>
				<img
					src="${this.bannerImageTori}"
					alt="${this.i18n.t({
						id: 'bip.tori.banner.image.ariaLabel',
						message: 'A red circle that contains the words "ToriDiili - secure payment, smooth delivery"',
					})}"
					class="flex flex-1 items-center max-w-4/10 object-cover max-h-full"
					style="aspect-ratio: 10/3;"
				/>
			</section>`;
		}
	}
}

if (!customElements.get('static-banner')) {
	customElements.define('static-banner', StaticBanner);
}
